// extracted by mini-css-extract-plugin
export default {"avatarContainer":"avatarContainer-fSGPniHT","replayControlAvatar":"replayControlAvatar-WFXi_6bg","selected":"selected-eHxO0UKP","tooltipMenu":"tooltipMenu-gbiTlYOC"};